module.exports = __webpack_public_path__ + "img/22_DSC8126.285e50eb.jpg";